import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import linkPage from '@editor/droplets/_bubble-options/components/link-page';
import tooltip from '@/mixins/components/tooltip';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-text-blob', {
  template: require('./template.html'),
  name: 'edit-text-blob',
  computed: {
    ...mapGetters(['currentSite']),
    enabledTypes() {
      const { type, addedTypes = [] } = this.currentSite;
      const allTypes = ['Choose...', type].concat(addedTypes);
      return _.uniq(allTypes).filter(type => type !== 'general');
    },
    dynamicKeyOptions() {
      const options = {
        restaurant: ['name', 'description', 'plainText', 'price', 'publishedOn'],
        blog: ['title', 'author', 'post', 'plainText', 'publishedOn'],
        serviceCompany: ['title', 'summary', 'plainText', 'projectDate', 'publishedOn'],
        media: ['title', 'author', 'released', 'summary', 'plainText', 'publishedOn'],
        profiles: ['name', 'address', 'description', 'plainText', 'publishedOn'],
        places: ['name', 'address', 'description', 'plainText', 'publishedOn'],
        products: ['name', 'description', 'plainText', 'price', 'productInventory', 'publishedOn'],
      };
      return options[this.activeSiteType] || ['Choose...'];
    },
  },
  components: {
    linkPage,
    tooltip,
    linkDynamic,
  },
  props: [
    'droplet',
    'show-edit-bubble',
    'active-site-type',
    'dynamic-data',
    'dynamic-item',
  ],
  data() {
    return {
      tags: [
        'div',
        'span',
        'p',
        'header',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
      ],
      display: {
        text: '',
        tag: 'div',
        hasLink: false,
        truncate: false,
        truncateLimit: 200,
        siteType: false,
        latestDynamic: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValies();
      }
    },
  },
  methods: {
    setInitialValies() {
      this.display.text = this.droplet.text;
      this.display.tag = this.droplet.tag;
      this.display.hasLink = this.droplet.hasLink;
      this.display.truncate = this.droplet.truncate;
      this.display.truncateLimit = this.droplet.truncateLimit;
      this.display.latestDynamic = this.droplet.latestDynamic;
      this.display.siteType = this.droplet.siteType || this.enabledTypes[0];
      this.display.dynamicKey = this.droplet.dynamicKey || this.dynamicData.newAddVal;
    },
    setDynamicType() {
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        val: this.display.siteType || null,
        key: 'siteType',
      });
      this.display.dynamicKey = this.dynamicKeyOptions[0];
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/text-blob/components/_edit-options/index.js